import React, {useState, useEffect} from 'react';
import './Clock.css'

function Clock({timeZone}) {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const tick = () => {
            const currentTime = new Date().toLocaleString("en-US", {timeZone});
            setTime(new Date(currentTime))
        }

        const intervalId = setInterval(tick, 1000);

        return () => clearInterval(intervalId);
    }, [timeZone])

    const formatTime = (date) => {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    return (
        <>{formatTime(time)}</>
    );
}

export default Clock;